import { Color, MeshPhongMaterial, } from "three";
var CONFIGS = [
    {
        name: 'Orange',
        color: 0xd26f2d,
        specular: 0
    },
    {
        name: 'Pink',
        color: 0xc38383,
        specular: 0
    },
    {
        name: 'Magenta',
        color: 0x922aa7,
        specular: 0
    },
    {
        name: 'Red',
        color: 0xce3b51,
        specular: 0.15
    },
    {
        name: 'Purple',
        color: 0x7a5487,
        specular: 0.15
    },
    {
        name: 'Blue',
        color: 0x5e44c5,
        specular: 0.15
    },
    {
        name: 'Logo',
        brightness: 0.9,
        specular: 0,
        vertexColors: true
    },
    {
        name: 'Astronaut',
        color: 0x7f7f7f,
        brightness: 1,
        specular: 0
    },
    {
        name: 'AstronautMask',
        color: 0x1b376e,
        brightness: 1,
        specular: 0.4
    },
    {
        name: 'Airplane',
        color: 0xff4f17,
        brightness: 1,
        specular: 0
    },
    {
        name: 'AirplaneWindow',
        color: 0x6e1600,
        brightness: 1,
        specular: 0.3
    },
    {
        name: 'Dinosaur',
        color: 0xffffff,
        brightness: 0.7,
        specular: 0,
        vertexColors: true
    },
    {
        name: 'Dumpling1',
        color: 0xc99dd7,
        specular: 0,
        bumpMap: 'rough',
        bumpScale: 0.3,
        aoMap: 'dumpling_ao1',
        aoMapIntensity: 1,
    },
    {
        name: 'Dumpling2',
        color: 0x8843a8,
        specular: 0.1,
        shininess: 30,
        bumpMap: 'rough',
        bumpScale: 0.3,
        aoMap: 'dumpling_ao2',
        aoMapIntensity: 1,
    },
    {
        name: 'Dumpling3',
        color: 0x741661,
        specular: 0.1,
        shininess: 30,
        bumpMap: 'rough',
        bumpScale: 0.3,
        aoMap: 'dumpling_ao3',
        aoMapIntensity: 1,
    },
];
var Materials = /** @class */ (function () {
    function Materials(params) {
        this.configs = CONFIGS;
        this.depthTest = true;
        this.textures = params.textures;
        this.materials = [];
        var len = CONFIGS.length;
        for (var i = 0; i < len; i++) {
            var config = CONFIGS[i];
            var material = void 0;
            // ------------------------------ Material
            material = this.materials[i] = new MeshPhongMaterial({
                color: config.brightness ? new Color(config.color).multiplyScalar(config.brightness) : config.color,
                specular: new Color(0xffffff).multiplyScalar(config.specular),
                shininess: 10,
                depthTest: this.depthTest
            });
            if (config.vertexColors) {
                material.vertexColors = config.vertexColors;
            }
            if (config.bumpMap) {
                material.bumpMap = params.textures[config.bumpMap];
                material.bumpScale = config.bumpScale;
            }
            if (config.aoMap) {
                material.aoMap = params.textures[config.aoMap];
                material.aoMapIntensity = config.aoMapIntensity;
            }
        }
    }
    Materials.prototype.getMaterialByName = function (name) {
        var index = this.configs.findIndex(function (config) {
            return config.name === name;
        });
        return index >= 0 ? this.materials[index] : null;
    };
    Materials.prototype.getMaterialsByNames = function (names) {
        var _this = this;
        if (!Array.isArray(names))
            names = [names];
        var materials = names.map(function (name) {
            return _this.getMaterialByName(name);
        });
        if (materials.length <= 1) {
            return materials[0];
        }
        else {
            return materials;
        }
    };
    return Materials;
}());
export { Materials };
